import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { PauseCircle, PlayCircle } from "@mui/icons-material";

export default function MarketingAutomationControl({
  settings,
  api,
  onChanged,
}) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const enabled = settings?.isEnabled !== false;
  const submit = async () => {
    setBusy(true);
    try {
      const result = await api.setAutomation(!enabled, reason);
      if (!result.success) throw new Error(result.message);
      enqueueSnackbar(result.message || "Marketing automation updated.", {
        variant: "success",
      });
      setOpen(false);
      setReason("");
      await onChanged();
    } catch (requestError) {
      enqueueSnackbar(requestError.message, { variant: "error" });
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Alert
        severity={enabled ? "success" : "error"}
        action={
          <Button
            color="inherit"
            onClick={() => setOpen(true)}
            startIcon={enabled ? <PauseCircle /> : <PlayCircle />}
          >
            {enabled ? "Pause all" : "Resume all"}
          </Button>
        }
      >
        <Typography fontWeight={700}>
          Marketing automation is {enabled ? "running" : "globally paused"}
        </Typography>
        {!enabled &&
          (settings?.pauseReason ||
            "Enrollment, progression and journey delivery are stopped.")}
      </Alert>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {enabled
            ? "Pause all marketing automation?"
            : "Resume marketing automation?"}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <Typography>
              {enabled
                ? "No journeys will enroll, progress or start sending. Pending history is retained and transactional emails are unaffected."
                : "Normal checks for eligibility, delivery windows and sender capacity will apply before anything is sent."}
            </Typography>
            {enabled && (
              <TextField
                label="Internal reason (optional)"
                value={reason}
                onChange={(event) => setReason(event.target.value)}
                multiline
                minRows={2}
              />
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            color={enabled ? "error" : "primary"}
            variant="contained"
            disabled={busy}
            onClick={submit}
          >
            {enabled ? "Pause all" : "Resume all"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
